import { PageShell, PoliciesSection } from "@/components/sections";

const Policies = () => (
  <PageShell testId="policies-page">
    <PoliciesSection />
  </PageShell>
);

export default Policies;
